import React, { ReactNode } from 'react'

import { STANDARD_WIDGET_SCALE_FACTOR } from 'components_new/organisms/Widget'

import { TCustomization } from 'types/GlobalCustomization'

import Box from 'components_new/atoms/Box'
import { MOBILE_FOOTER_HEIGHT } from 'components_new/templates/GlobalLayout'

interface MobileProps {
  children: (props: { scaleFactor: number }) => ReactNode
  customization?: TCustomization
}

const Mobile = (props: MobileProps) => {
  const { children, customization } = props

  return (
    <>
      <Box
        sx={{
          height: '100%',
          position: 'relative',
          bgcolor:
            customization?.background_colors?.default ?? 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          p: 1,
          pb: `${MOBILE_FOOTER_HEIGHT + 64}px`
        }}
      >
        {children({ scaleFactor: STANDARD_WIDGET_SCALE_FACTOR })}

        {/*-- footer bleed --*/}
        <Box
          sx={{
            height: MOBILE_FOOTER_HEIGHT,
            minHeight: MOBILE_FOOTER_HEIGHT
          }}
        />
      </Box>
    </>
  )
}

Mobile.displayName = 'Mobile'

export default Mobile
